import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import DOMPurify from "dompurify";
import ErrorExtractor from "../common/error_extractor";
import CommonDropdown from "../common/common_dropDown";
import {
  submitVendorAPI,
  saveAttachmentApi,
  saveMSMEAttachmentApi,
  saveGSTAttachmentApi,
  updateVendorAPI,
  getVendorEditApi,
} from "./vendor-api";
import addImage from "../../assets/svg/add-image.svg";
import { X } from "lucide-react"; // Close icon
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import AsyncSelect from "react-select/async";
import axios from "axios";
import { getCookie } from "../../getcookie";
import { apiCall, apiCallAdmin } from "../../services/api-service";

export const VendorCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "1px solid #D4DDE7",
      padding: "0px 8px",
      fontWeight: "400",
      fontSize: "13px",
      color: "#212129",
      minHeight: "38px",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#888888",
      fontSize: "13px",
      fontWeight: "400",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 6px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
          ? "#e0e0e0"
          : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
      maxWidth: "120px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [isLoader, setIsLoader] = useState(false);

  // Reset scroll position to top on page mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [vendorType, setVendorType] = useState("all"); // single | all
  const options = [
    { label: "All", value: "all" },
    { label: "Single", value: "single" },
  ];
  useEffect(() => {
    if (id != null) {
      getVendorEdit(id);
    }
  }, [id]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [selectedAppList, setSelectedAppList] = useState([]);
  const [removeAppList, setRemoveAppList] = useState([]);
  const [selectedProjectList, setSelectedProjectList] = useState([]);
  const [removeProjectList, setRemoveProjectList] = useState([]);
  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [imageRemoved, setImageRemoved] = useState(false);

  const [dragging, setDragging] = useState(false);

  const handleInputFile = () => {
    fileInputRef.current.click();
  };
  const handleAutoAppDropdownChange = (selectedOptions) => {
    // Find removed options
    const removed = selectedAppList.filter(
      (oldItem) =>
        !selectedOptions?.some((newItem) => newItem.value === oldItem.value),
    );

    if (removed.length > 0) {
      setRemoveAppList((prev) => [...prev, ...removed]);
    }

    setSelectedAppList(selectedOptions);
  };
  const handleProjectDropdownChange = (selectedOptions) => {
    // Find removed options
    const removed = selectedProjectList.filter(
      (oldItem) =>
        !selectedOptions?.some((newItem) => newItem.value === oldItem.value),
    );

    if (removed.length > 0) {
      setRemoveProjectList((prev) => [...prev, ...removed]);
    }

    setSelectedProjectList(selectedOptions);
  };
  const fetchOptionsAutoApp = (inputValue, callback) => {
    apiCallAdmin("get", `get_enabled_app?&term=${inputValue || ""}`)
      .then((response) => {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options); // ✅ Must call callback to update AsyncSelect
      })
      .catch((error) => {
        console.error("API Error:", error);
        callback([]); // return empty on error
      });
  };
  const fetchOptionsProjects = (inputValue, callback) => {
    apiCall("get", `get_project?&term=${inputValue || ""}`)
      .then((response) => {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      })
      .catch((error) => {
        console.error("API Error:", error);
        callback([]);
      });
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  const [vendorName, setVendorName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [CompanyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  const [code, setCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [owner, setOwner] = useState("");
  const [stageOption, setStageOption] = useState(null);
  const [industryOption, setIndustryOption] = useState(null);
  const [subIndustryOption, setSubIndustryOption] = useState(null);
  const [gradeOption, setGradeOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);
  const [categoryOption, setCategoryOption] = useState(null);

  const [shipAddress, setShipAddress] = useState("");
  const [shipCountryOption, setShipCountryOption] = useState(null);
  const [shipStateOption, setShipStateOption] = useState(null);
  const [shipCityOption, setShipCityOption] = useState(null);
  const [shipZipCode, setShipZipCode] = useState("");

  const [isBillAddress, setIsBillAddress] = useState(false);
  const [billAddress, setBillAddress] = useState("");
  const [billCountryOption, setBillCountryOption] = useState(null);
  const [billStateOption, setBillStateOption] = useState(null);
  const [billCityOption, setBillCityOption] = useState(null);
  const [billZipCode, setBillZipCode] = useState("");

  const [loginRequired, setLoginRequired] = useState(false);
  const [roleOption, setRole] = useState(null);

  const [panNumber, setPanNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [msmeNumber, setMsmeNumber] = useState("");
  const [tanNumber, setTanNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");

  const [taxCountryOption, setTaxCountryOption] = useState(null);
  const [taxTypeOption, setTaxTypeOption] = useState(null);
  const [currencyOption, setCurrencyOption] = useState(null);
  const [bankName, setBankName] = useState("");
  const [holderName, setHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [gstDocuments, setGstDocuments] = useState([]);
  const [msmeDocuments, setMsmeDocuments] = useState([]);
  const [gstDocumentsUrl, setGstDocumentsUrl] = useState([]);
  const [msmeDocumentsUrl, setMsmeDocumentsUrl] = useState([]);
  const [removedGstDocuments, setRemovedGstDocuments] = useState([]);
  const [removedMsmeDocuments, setRemovedMsmeDocuments] = useState([]);

  const [notificationEmails, setNotificationEmails] = useState([]);
  const [newNotificationEmail, setNewNotificationEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleAddNotificationEmail = () => {
    const trimmedEmail = newNotificationEmail.trim().toLowerCase();
    if (!trimmedEmail) {
      setEmailError("Email cannot be empty");
      return;
    }
    if (!validateEmail(trimmedEmail)) {
      setEmailError("Please enter a valid email address");
      return;
    }
    if (
      notificationEmails.some((email) => email.toLowerCase() === trimmedEmail)
    ) {
      setEmailError("This email is already added");
      return;
    }
    setNotificationEmails([...notificationEmails, trimmedEmail]);
    setNewNotificationEmail("");
    setEmailError("");
  };

  const handleRemoveNotificationEmail = (emailToRemove) => {
    setNotificationEmails(
      notificationEmails.filter((email) => email !== emailToRemove),
    );
  };

  const handleSelectStage = (item) => {
    setStageOption(item);
  };

  const [errorMsg, setErrorMsg] = useState({
    company_name: "",
    stage: "",
    mobile_number: "",
    email: "",
    grade_id: "",
    industry_id: "",
    sub_industry_id: "",
    owner: "",
    ship_address: "",
    ship_city_id: "",
    ship_state_id: "",
    ship_country_id: "",
    ship_zipcode: "",
    bill_address: "",
    bill_city_id: "",
    bill_state_id: "",
    bill_country_id: "",
    bill_zipcode: "",
    location_id: "",
    pan_number: "",
    tax_number: "",
    msme_number: "",
    tan_number: "",
    vat_number: "",
    tax_country_id: "",
    tax_type: "",
    currency_id: "",
    bank_name: "",
    holder_name: "",
    bank_account_number: "",
    ifsc_code: "",
    projects: "",
    notification_emails: "",
    gst_documents: "",
    msme_documents: "",
    role: "",
    category_id: "",
  });

  const submitForm = async () => {
    if (isLoader) return;
    const errors = {};
    if (!companyName || !companyName.trim()) {
      errors.company_name = "Company Name is required";
    }
    if (!CompanyRegistrationNumber || !CompanyRegistrationNumber.trim()) {
      errors.company_registration_number = "Company Registration Number is required";
    }
    if (!email || !email.trim()) {
      errors.email = "Email is required";
    }
    if (!phoneNumber || !phoneNumber.trim()) {
      errors.mobile_number = "Mobile Number is required";
    }
    if (!owner || !owner.trim()) {
      errors.owner = "Owner name is required";
    }
    if (shipCountryOption && !shipStateOption) {
      errors.ship_state_id = "Shipping State is required";
    }
    if (shipStateOption && !shipCityOption) {
      errors.ship_city_id = "Shipping City is required";
    }
    if (billCountryOption && !billStateOption) {
      errors.bill_state_id = "Billing State is required";
    }
    if (billStateOption && !billCityOption) {
      errors.bill_city_id = "Billing City is required";
    }

    if (Object.keys(errors).length > 0) {
      setErrorMsg(errors);
      return;
    }

    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        company_name: companyName,
        company_registration_number: CompanyRegistrationNumber,
        vendor_name: vendorName,
        vendor_code: code,
        stage_id: stageOption != null ? stageOption.value : "",
        mobile_number: phoneNumber,
        email: email,
        grade_id: gradeOption != null ? gradeOption.value : "",
        industry_id: industryOption != null ? industryOption.value : "",
        sub_industry_id:
          subIndustryOption != null ? subIndustryOption.value : "",
        owner: owner,
        ship_address: shipAddress,
        ship_city_id: shipCityOption != null ? shipCityOption.value : "",
        ship_state_id: shipStateOption != null ? shipStateOption.value : "",
        ship_country_id:
          shipCountryOption != null ? shipCountryOption.value : "",
        ship_zipcode: shipZipCode,
        bill_address: billAddress,
        bill_city_id: billCityOption != null ? billCityOption.value : "",
        bill_state_id: billStateOption != null ? billStateOption.value : "",
        bill_country_id:
          billCountryOption != null ? billCountryOption.value : "",
        bill_zipcode: billZipCode,
        login_required: loginRequired,
        all_apps: vendorType === "single" ? false : true,
        role: roleOption != null ? roleOption.value : "",
        applications: selectedAppList.map((item) => item.value),
        projects: selectedProjectList.map((item) => item.value),
        location_id: locationOption != null ? locationOption.value : "",
        pan_number: panNumber,
        tax_number: gstNumber,
        msme_number: msmeNumber,
        tan_number: tanNumber,
        vat_number: vatNumber,
        tax_country_id: taxCountryOption != null ? taxCountryOption.value : "",
        tax_type: taxTypeOption != null ? taxTypeOption.value : "",
        currency_id: currencyOption != null ? currencyOption.value : "",
        bank_name: bankName,
        holder_name: holderName,
        bank_account_number: accountNumber,
        ifsc_code: ifscCode,
        category_id: categoryOption != null ? categoryOption.value : "",
        profile_removed: imageRemoved,

        notification_emails: notificationEmails,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value) ||
          key === "assignee"
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitVendorAPI(sanitizedData);
      } else {
        response = await updateVendorAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            company_name: "",
            company_registration_number: "",
            stage: "",
            mobile_number: "",
            email: "",
            grade_id: "",
            industry_id: "",
            sub_industry_id: "",
            owner: "",
            ship_address: "",
            ship_city_id: "",
            ship_state_id: "",
            ship_country_id: "",
            ship_zipcode: "",
            bill_address: "",
            bill_city_id: "",
            bill_state_id: "",
            bill_country_id: "",
            bill_zipcode: "",
            location_id: "",
            pan_number: "",
            tax_number: "",
            msme_number: "",
            tan_number: "",
            vat_number: "",
            tax_country_id: "",
            tax_type: "",
            currency_id: "",
            bank_name: "",
            holder_name: "",
            bank_account_number: "",
            ifsc_code: "",
            projects: "",
            notification_emails: "",
            gst_documents: "",
            msme_documents: "",
            category_id: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        console.log("saveAttachment called 0");
        if (
          image === null &&
          imageRemoved === false &&
          gstDocuments.length === 0 &&
          removedGstDocuments.length === 0 &&
          removedMsmeDocuments.length === 0 &&
          msmeDocuments.length === 0
        ) {
          console.log("saveAttachment called 1");
          navigate(-1);
        } else {
          console.log("saveAttachment called 2");

          const attachmentPromises = [];

          if (image !== null || imageRemoved === true) {
            attachmentPromises.push(saveAttachment(response.data.id));
          }

          if (gstDocuments.length > 0 || removedGstDocuments.length > 0) {
            attachmentPromises.push(saveGSTAttachment(response.data.id));
          }
          if (msmeDocuments.length > 0 || removedMsmeDocuments.length > 0) {
            attachmentPromises.push(saveMSMEAttachment(response.data.id));
          }

          // Wait for all attachment uploads to complete
          await Promise.all(attachmentPromises);
          navigate(-1);
        }
      } else {
        setSnackbarMessage(
          response.data?.message || "Something went wrong."
        );
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      } else {
        setSnackbarMessage(
          err.response?.data?.message || "Something went wrong."
        );
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } finally {
      setIsLoader(false);
    }
  };
  const saveAttachment = async (parentId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        attachment: image != null ? image : imageRemoved === true ? "" : "",
      };
      const response = await saveAttachmentApi(parentId, data);
      return response;
    } catch (err) {
      console.error("Error fetching options:", err);
      throw err;
    }
  };

  const saveMSMEAttachment = async (parentId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        removed_attachments: removedMsmeDocuments,
        attachments: msmeDocuments
          .filter((doc) => doc.data && !doc.file)
          .map((doc) => ({
            file_name: doc.name,
            base64: doc.data,
          })),
      };
      const response = await saveMSMEAttachmentApi(parentId, data);
      return response;
    } catch (err) {
      console.error("Error fetching options:", err);
      throw err;
    }
  };

  const saveGSTAttachment = async (parentId) => {
    console.log("saveAttachment called");
    console.log(gstDocuments.filter((doc) => doc.data && !doc.file));
    try {
      const data = {
        removed_attachments: removedGstDocuments,

        attachments: gstDocuments
          .filter((doc) => doc.data && !doc.file)
          .map((doc) => ({
            file_name: doc.name,
            base64: doc.data,
          })),
      };
      const response = await saveGSTAttachmentApi(parentId, data);
      return response;
    } catch (err) {
      console.error("Error fetching options:", err);
      throw err;
    }
  };
  const getVendorEdit = async (id) => {
    try {
      const response = await getVendorEditApi(id);

      if (response.data.success === true) {
        const vendorDetail = response.data.vendor ?? {};

        setVendorName(vendorDetail.vendor_name ?? "");
        setCompanyName(vendorDetail.company_name ?? "");
        setCompanyRegistrationNumber(
          vendorDetail.company_registration_number ?? "",
        );
        setPhoneNumber(vendorDetail.mobile_number ?? "");
        setEmail(vendorDetail.email ?? "");
        setOwner(vendorDetail.owner ?? "");
        setCode(vendorDetail.vendor_code ?? "");
        setLoginRequired(vendorDetail.login_require ?? "");
        setVendorType(vendorDetail.all_apps === true ? "all" : "single");
        setSelectedAppList(vendorDetail.applications ?? []);
        setSelectedProjectList(vendorDetail.projects ?? []);
        setStageOption({
          value: vendorDetail.stage_id ?? "",
          label: vendorDetail.stage ?? "",
        });
        setIndustryOption({
          value: vendorDetail.industry_id ?? "",
          label: vendorDetail.industry ?? "",
        });
        setSubIndustryOption({
          value: vendorDetail.sub_industry_id ?? "",
          label: vendorDetail.sub_industry ?? "",
        });
        setGradeOption({
          value: vendorDetail.grade_id ?? "",
          label: vendorDetail.grade ?? "",
        });
        setLocationOption(
          vendorDetail.location_id
            ? {
                value: vendorDetail.location_id,
                label: vendorDetail.location ?? "",
              }
            : null,
        );
        setShipAddress(vendorDetail.ship_address ?? "");
        setShipCityOption({
          value: vendorDetail.ship_city_id ?? "",
          label: vendorDetail.ship_city ?? "",
        });
        setShipStateOption({
          value: vendorDetail.ship_state_id ?? "",
          label: vendorDetail.ship_state ?? "",
        });
        setShipCountryOption({
          value: vendorDetail.ship_country_id ?? "",
          label: vendorDetail.shipping_country ?? "",
        });

        setShipZipCode(vendorDetail.ship_zipcode);

        setBillAddress(vendorDetail.bill_address ?? "");
        setBillCityOption({
          value: vendorDetail.bill_city_id ?? "",
          label: vendorDetail.bill_city ?? "",
        });
        setBillStateOption({
          value: vendorDetail.bill_state_id ?? "",
          label: vendorDetail.billing_state ?? "",
        });
        setBillCountryOption({
          value: vendorDetail.bill_country_id ?? "",
          label: vendorDetail.bill_country ?? "",
        });
        setRole({
          value: vendorDetail.role_value ?? "",
          label: vendorDetail.role_label ?? "",
        });

        setBillZipCode(vendorDetail.bill_zipcode);

        setImageUrl(vendorDetail.image ?? "");

        setPanNumber(vendorDetail.pan_number ?? "");
        setGstNumber(vendorDetail.tax_number ?? vendorDetail.gst_number ?? "");
        setMsmeNumber(vendorDetail.msme_number ?? "");
        setTanNumber(vendorDetail.tan_number ?? "");
        setVatNumber(vendorDetail.vat_number ?? "");
        setTaxCountryOption(
          vendorDetail.tax_country_id
            ? {
                value: vendorDetail.tax_country_id,
                label: vendorDetail.tax_country ?? "",
              }
            : null,
        );
        setTaxTypeOption(
          vendorDetail.tax_type
            ? {
                value: vendorDetail.tax_type_id ?? vendorDetail.tax_type,
                label: vendorDetail.tax_type ?? "",
              }
            : null,
        );
        setCurrencyOption(
          vendorDetail.currency_id
            ? {
                value: vendorDetail.currency_id,
                label: vendorDetail.currency ?? "",
              }
            : null,
        );
        setBankName(vendorDetail.bank_name ?? "");
        setHolderName(vendorDetail.holder_name ?? "");
        setAccountNumber(
          vendorDetail.bank_account_number ?? vendorDetail.account_number ?? "",
        );
        setIfscCode(vendorDetail.ifsc_code ?? "");
        setGstDocumentsUrl(
          vendorDetail.gst_attachments ?? vendorDetail.gst_documents ?? [],
        );
        setMsmeDocumentsUrl(
          vendorDetail.msme_attachments ?? vendorDetail.msme_documents ?? [],
        );
        setNotificationEmails(vendorDetail.notification_emails ?? []);
        setCategoryOption(
          vendorDetail.category_id
            ? {
                value: vendorDetail.category_id,
                label: vendorDetail.category ?? "",
              }
            : null,
        );
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  return (
    <div className="d-flex ">
      <Sidebar currentfile="Vendors" />
      <div className="rounded-4 flex-grow-1  ">
        <Navbar pageTitle="Vendors" />
        <div className="bg-half-white" style={{ background: "#F5F8FA" }}>
          <div>
            <div className="bg-white px-2 d-flex align-items-center justify-content-between">
              <div className="d-flex gap-3 my-3">
                <MoveLeft
                  className="cursor-pointer"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                <p className="fw-semibold m-0">New vendor</p>
              </div>
              <div className="d-flex gap-3">
                <Button
                  className="cursor-pointer bg-white rounded-pill px-4 py-2  btn-border-grey fs-15 fw-500"
                  style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                  onClick={() => {
                    navigate(-1);
                  }}
                  disabled={isLoader}
                >
                  Cancel
                </Button>
                <Button
                  className={`cursor-pointer dark-purple-btn ${
                    isLoader ? "disabled-btn" : ""
                  } rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                  onClick={() => {
                    submitForm();
                  }}
                  disabled={isLoader}
                  style={{ minWidth: "100px" }}
                >
                  {isLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : id != null ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
            </div>

            {/* Visual Stepper Progress Bar */}
            <div className="mx-2 my-3 p-3 bg-white rounded-4 border-0 d-flex justify-content-around align-items-center" style={{ boxShadow: "rgba(0, 0, 0, 0.02) 0px 4px 12px" }}>
              <div className="d-flex align-items-center gap-2">
                <span className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold fs-12" style={{ backgroundColor: "#2563EB", width: "24px", height: "24px" }}>1</span>
                <span className="fs-14 fw-600 textcolor">Vendor & Contact Details</span>
              </div>
              <div className="flex-grow-1 mx-3" style={{ height: "2px", backgroundColor: "#E5E7EB", maxWidth: "200px" }}></div>
              <div className="d-flex align-items-center gap-2">
                <span className="d-flex align-items-center justify-content-center rounded-circle text-white fw-bold fs-12" style={{ backgroundColor: "#10B981", width: "24px", height: "24px" }}>2</span>
                <span className="fs-14 fw-600 textcolor">Tax & Attachment Details</span>
              </div>
            </div>

            <div className="m-2 bg-white rounded-4 p-3">
              <div className="row">
                <div className="col-xl-10 col-xxl-9  col-12 ">
                  <div className="row">
                    <div className="col-xl-12">
                      <p className="fs-18 fw-600 mb-0">Vendor Details </p>
                    </div>
                    <div
                      className="col-xl-6"
                      style={{
                        alignItems: "center",
                        justifyContent: "start",
                        display: "flex",
                        gap: 20,
                      }}
                    >
                      <div className="col-xl-12">
                        <div className="col-xl-12 col-12">
                          <label
                            htmlFor="vendor-name"
                            className="form-label d-flex fw-400 mt-2"
                          >
                            Company Name<span className="error-text">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control rounded-3 vendor-form-input"
                            id="vendor-name"
                            placeholder="Enter here"
                            value={companyName}
                            onChange={(e) => {
                              setCompanyName(e.target.value);
                            }}
                          />{" "}
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                              marginTop: "0px",
                              marginLeft: "6px",
                            }}
                          >
                            {errorMsg.company_name}
                          </span>
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <div className="col-xl-12 col-12">
                          <label
                            htmlFor="vendor-name"
                            className="form-label d-flex fw-400 mt-2"
                          >
                            Company Registration No
                          </label>
                          <input
                            type="text"
                            className="form-control rounded-3 vendor-form-input"
                            id="vendor-name"
                            placeholder="Enter here"
                            value={CompanyRegistrationNumber}
                            onChange={(e) => {
                              setCompanyRegistrationNumber(e.target.value);
                            }}
                          />{" "}
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                              marginTop: "0px",
                              marginLeft: "6px",
                            }}
                          >
                            {errorMsg.company_registration_number}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-xl-12"
                      style={{
                        alignItems: "center",
                        justifyContent: "start",
                        display: "flex",
                        gap: 20,
                      }}
                    >
                      <div className="col-xl-4">
                        <div className="col-xl-12 col-6">
                          <label
                            htmlFor="vendor-name"
                            className="form-label  fw-400 mt-2"
                          >
                            Code
                          </label>
                          <input
                            type="text"
                            className="form-control rounded-3 vendor-form-input"
                            id="vendor-name"
                            placeholder="Enter here"
                            value={code}
                            onChange={(e) => {
                              setCode(e.target.value);
                            }}
                          />{" "}
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                              marginTop: "0px",
                              marginLeft: "6px",
                            }}
                          >
                            {errorMsg.vendor_code}
                          </span>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="col-xl-12 col-12">
                          <label
                            htmlFor="vendor-name"
                            className="form-label  d-flex fw-400 mt-2"
                          >
                            Vendor Name<span className="error-text">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control rounded-3 vendor-form-input"
                            id="vendor-name"
                            placeholder="Enter here"
                            value={vendorName}
                            onChange={(e) => {
                              setVendorName(e.target.value);
                            }}
                          />{" "}
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                              marginTop: "0px",
                              marginLeft: "6px",
                            }}
                          >
                            {errorMsg.vendor_name}
                          </span>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="col-xl-12 col-12">
                          <label
                            htmlFor="vendor-category"
                            className="form-label d-flex fw-400 mt-2"
                          >
                            Vendor Category
                          </label>
                          <CommonDropdown
                            apiUrl={`${apiUrl}get_category?term=`}
                            placeholder="Select"
                            value={categoryOption}
                            onSelect={(item) => {
                              setCategoryOption(item);
                            }}
                          />
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                              marginTop: "0px",
                              marginLeft: "6px",
                            }}
                          >
                            {errorMsg.category_id}
                          </span>
                        </div>
                      </div>
                      {/* <div className="col-xl-6">
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "left", gap: 10 }}>
                          <label htmlFor="login-required" className="form-label fw-600" style={{ marginTop: 40 }}>
                            <span style={{ fontSize: 16 }}>Login Required</span>
                          </label>
                          <div className="form-check" style={{ marginTop: 30 }}>
                            <input type="checkbox" id="login-required" className="form-check-input" checked={loginRequired} onChange={(e) => setLoginRequired(e.target.checked)} />
                          </div>
                        </div>
                      </div> */}
                      {loginRequired && (
                        <div className="mt-4 col-md-11 col-xl-11 col-12 d-flex  align-items-center justify-content-start">
                          <label
                            htmlFor="stageOption"
                            className="form-label  fw-400 my-0 d-flex"
                            style={{
                              width: "80px",
                              fontSize: 16,
                              marginLeft: "-90px",
                            }}
                          >
                            <span style={{ fontSize: 16 }}>Role</span>
                          </label>
                          <div
                            style={{
                              width: "calc(100% - 80px)",
                              marginLeft: "-30px",
                            }}
                          >
                            <CommonDropdown
                              apiUrl={`${adminUrl}get_role`}
                              placeholder="Select Role"
                              value={roleOption}
                              onSelect={(item) => {
                                setRole(item);
                              }}
                            />{" "}
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                                marginTop: "0px",
                                marginLeft: "6px",
                              }}
                            >
                              {errorMsg.role}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-xl-12 mt-2 mb-1">
                      <p className="fs-18 fw-600 mb-0">Basic Details </p>
                    </div>

                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <label
                        htmlFor="stageOption"
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ width: "80px" }}
                      >
                        Stage
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_vendor_stage`}
                          placeholder="Select"
                          value={stageOption}
                          onSelect={(item) => {
                            setStageOption(item);
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.stage}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-start justify-content-start">
                      <label
                        htmlFor="msmeNumber"
                        className="form-label  fw-400 my-0 d-flex me-2 mt-2"
                        style={{ width: "80px" }}
                      >
                        MSME Number
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <input
                          type="text"
                          className="form-control rounded-3 vendor-form-input"
                          id="msmeNumber"
                          placeholder="Enter MSME Number"
                          value={msmeNumber}
                          onChange={(e) => {
                            setMsmeNumber(e.target.value);
                          }}
                        />
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "4px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.msme_number}
                        </span>
                      </div>
                    </div>
                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <div
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ minWidth: "80px" }}
                      >
                        Industry
                      </div>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_industry`}
                          placeholder="Select"
                          value={industryOption}
                          onSelect={(item) => {
                            setIndustryOption(item);
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.industry_id}
                        </span>
                      </div>
                    </div>
                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <label
                        htmlFor="stageOption"
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ width: "80px" }}
                      >
                        Sub Industry
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_sub_industry?industry_id=${
                            industryOption != null ? industryOption.value : ""
                          }`}
                          placeholder="Select"
                          value={subIndustryOption}
                          onSelect={(item) => {
                            setSubIndustryOption(item);
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.sub_industry_id}
                        </span>
                      </div>
                    </div>
                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <label
                        htmlFor="stageOption"
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ width: "80px" }}
                      >
                        Phone
                        {/* <span className="error-text">*</span> */}
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <input
                          type="text"
                          className="form-control rounded-3 vendor-form-input"
                          id="vendor-name"
                          placeholder="Enter here"
                          maxLength={12}
                          value={phoneNumber}
                          onChange={(e) => {
                            setPhoneNumber(e.target.value.replace(/\D/g, ""));
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.mobile_number}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <label
                        htmlFor="email"
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ width: "80px" }}
                      >
                        Email
                        {/* <span className="error-text">*</span> */}
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <input
                          type="text"
                          className="form-control rounded-3 vendor-form-input"
                          id="email"
                          placeholder="Enter here"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.email}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <label
                        htmlFor="Owner"
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ width: "80px" }}
                      >
                        Owner
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <input
                          type="text"
                          className="form-control rounded-3 vendor-form-input"
                          id="Owner"
                          placeholder="Enter here"
                          value={owner}
                          onChange={(e) => {
                            setOwner(e.target.value);
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.owner}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <label
                        htmlFor="Grade"
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ width: "80px" }}
                      >
                        Grade
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <CommonDropdown
                          apiUrl={`${apiUrl}get_grade`}
                          placeholder="Select"
                          value={gradeOption}
                          onSelect={(item) => {
                            setGradeOption(item);
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.grade_id}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 col-md-6 col-xl-6 col-12 d-flex  align-items-center justify-content-start">
                      <label
                        htmlFor="stageOption"
                        className="form-label  fw-400 my-0 d-flex me-2"
                        style={{ width: "80px" }}
                      >
                        Location
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <CommonDropdown
                          apiUrl={`${adminUrl}get_location`}
                          placeholder="Select"
                          value={locationOption}
                          onSelect={(item) => {
                            setLocationOption(item);
                          }}
                        />{" "}
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "0px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.location_id}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 col-md-12 col-xl-6 col-12 d-flex align-items-start justify-content-start">
                      <label
                        htmlFor="projects"
                        className="form-label fw-400 my-0 d-flex me-2 mt-2"
                        style={{ width: "80px" }}
                      >
                        Projects
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <AsyncSelect
                          isMulti
                          cacheOptions
                          value={selectedProjectList}
                          loadOptions={fetchOptionsProjects}
                          onChange={(selectedOptions) => {
                            handleProjectDropdownChange(selectedOptions);
                          }}
                          defaultOptions
                          placeholder="Select"
                          styles={multiselectCustomStyles}
                          isClearable={false}
                          menuPortalTarget={document.body}
                          menuPlacement="auto"
                        />
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "4px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.projects}
                        </span>
                      </div>
                    </div>

                    <div className="mt-2 col-md-6 col-xl-4 col-12 d-flex  align-items-center justify-content-start">
                      <div
                        className="d-flex gap-3 mt-2"
                        style={{ paddingLeft: "12px" }}
                      >
                        {options.map((opt) => {
                          const isActive = vendorType === opt.value;

                          return (
                            <label
                              key={opt.value}
                              style={{
                                fontSize: "13px",
                                fontWeight: isActive ? 700 : 500,
                                // padding: "4px 10px",
                                borderRadius: "8px",

                                color: isActive ? "#4F46E5" : "#172B4D",
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="radio"
                                name="options"
                                value={opt.value}
                                checked={isActive}
                                className="custom-radio"
                                onChange={() => setVendorType(opt.value)}
                                style={{
                                  marginRight: "6px",
                                  cursor: "pointer",
                                  accentColor: "#4F46E5",
                                }}
                              />
                              {opt.label}
                            </label>
                          );
                        })}
                      </div>
                    </div>
                    {vendorType === "single" && (
                      <div className="mt-2 col-md-6 col-xl-4 col-12 d-flex  align-items-center justify-content-start">
                        <label
                          htmlFor="Grade"
                          className="form-label  fw-400 my-0 d-flex me-2 mt-2"
                          style={{ width: "80px" }}
                        >
                          Application
                        </label>
                        <div className="col-xl-11 mt-xl-3">
                          <AsyncSelect
                            isMulti
                            cacheOptions
                            value={selectedAppList}
                            loadOptions={fetchOptionsAutoApp}
                            onChange={(selectedOptions) => {
                              handleAutoAppDropdownChange(selectedOptions);
                            }}
                            defaultOptions
                            placeholder="Search applications..."
                            styles={multiselectCustomStyles}
                            isClearable={false}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                          />{" "}
                          <span className="error-txt fs-12 fw-500 ">
                            {errorMsg.applications}
                          </span>
                        </div>
                      </div>
                    )}

                    {/* <div className="mt-2 col-md-12 col-xl-8 col-12 d-flex align-items-start justify-content-start">
                      <label
                        htmlFor="notificationEmails"
                        className="form-label fw-400 my-0 d-flex me-2 mt-2"
                        style={{ width: "80px" }}
                      >
                        Notification Email
                      </label>
                      <div style={{ width: "calc(100% - 80px)" }}>
                        <div className="d-flex gap-2 mb-2">
                          <input
                            type="email"
                            className="form-control rounded-3 vendor-form-input"
                            id="notificationEmails"
                            placeholder="Enter email address"
                            value={newNotificationEmail}
                            onChange={(e) => {
                              setNewNotificationEmail(e.target.value);
                              setEmailError("");
                            }}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleAddNotificationEmail();
                              }
                            }}
                          />
                          <Button
                            className="rounded-3 px-3"
                            style={{
                              backgroundColor: "#6c5ce7",
                              border: "none",
                              fontSize: "14px",
                              fontWeight: "500",
                              whiteSpace: "nowrap",
                            }}
                            onClick={handleAddNotificationEmail}
                          >
                            Add
                          </Button>
                        </div>
                        {emailError && (
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "start",
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                              marginBottom: "8px",
                            }}
                          >
                            {emailError}
                          </span>
                        )}
                        {notificationEmails.length > 0 && (
                          <div
                            className="d-flex flex-wrap gap-2"
                            style={{
                              padding: "8px",
                              backgroundColor: "#F8F9FA",
                              borderRadius: "8px",
                            }}
                          >
                            {notificationEmails.map((email, index) => (
                              <div
                                key={index}
                                className="d-flex align-items-center"
                                style={{
                                  backgroundColor: "#6c5ce7",
                                  color: "white",
                                  padding: "6px 12px",
                                  borderRadius: "20px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  gap: "8px",
                                }}
                              >
                                <span>{email}</span>
                                <X
                                  size={16}
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleRemoveNotificationEmail(email)
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="col-xl-2 col-xxl-2 col-12 ">
                  {image ? (
                    <>
                      <div
                        style={{
                          position: "relative",
                          width: "100px",
                          height: "100px",
                        }}
                      >
                        <div
                          onClick={handleInputFile}
                          onDrop={handleDrop}
                          onDragOver={(e) => e.preventDefault()}
                          onDragEnter={() => setDragging(true)}
                          onDragLeave={() => setDragging(false)}
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            objectFit: "cover",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={image}
                            className="rounded-circle"
                            alt="Uploaded Vehicle"
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <button
                          onClick={(e) => {
                            setImage(null);
                          }}
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            background: "white",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          <X size={16} color="#ff0000" />
                        </button>
                      </div>
                    </>
                  ) : imageUrl !== "" ? (
                    <>
                      <div
                        style={{
                          position: "relative",
                          width: "100px",
                          height: "100px",
                        }}
                      >
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            objectFit: "cover",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={imageUrl}
                            className="rounded-circle"
                            alt="Uploaded Vehicle"
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <button
                          onClick={(e) => {
                            setImageUrl("");
                            setImageRemoved(true);
                          }}
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            background: "white",
                            border: "none",
                            borderRadius: "50%",
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          <X size={16} color="#ff0000" />
                        </button>
                      </div>
                    </>
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center rounded-4 p-4"
                      style={{
                        width: "116px",
                        height: "116px",
                        background: "#F6F5FF",
                      }}
                      onClick={handleInputFile}
                      onDrop={handleDrop}
                      onDragOver={(e) => e.preventDefault()}
                      onDragEnter={() => setDragging(true)}
                      onDragLeave={() => setDragging(false)}
                    >
                      <img src={addImage} alt="add" />
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    className="d-none"
                    onChange={handleFileChange}
                  />
                </div>

                <div className="col-md-6 col-12 mt-4">
                  <p className="fs-16 fw-600 mb-3">MSME Documents</p>
                  <div
                    style={{
                      border: "1px dashed #E5E7EB",
                      borderRadius: "12px",
                      padding: "40px",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      document.getElementById("msmeDocInput").click()
                    }
                    onDrop={(e) => {
                      e.preventDefault();
                      if (e.dataTransfer.files.length > 0) {
                        const files = Array.from(e.dataTransfer.files).filter(file => {
                          const ext = file.name.split('.').pop().toLowerCase();
                          return ['pdf', 'png', 'jpg', 'jpeg'].includes(ext);
                        });
                        const promises = files.map((file) => {
                          return new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.onload = () => {
                              resolve({
                                name: file.name,
                                data: reader.result,
                                size: file.size,
                              });
                            };
                            reader.readAsDataURL(file);
                          });
                        });
                        Promise.all(promises).then((results) => {
                          setMsmeDocuments([...msmeDocuments, ...results]);
                        });
                      }
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    onDragEnter={(e) => e.preventDefault()}
                    onDragLeave={(e) => e.preventDefault()}
                  >
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#9CA3AF"
                        strokeWidth="1.5"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                        <polyline points="10 9 9 9 8 9" />
                      </svg>
                      <p
                        className="mt-3 mb-0"
                        style={{ color: "#6B7280", fontSize: "14px" }}
                      >
                        Drag and drop PDF files here or{" "}
                        <span style={{ color: "#3B82F6", fontWeight: "500" }}>
                          Choose from files
                        </span>
                      </p>
                    </div>
                  </div>
                  <input
                    id="msmeDocInput"
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg"
                    multiple
                    className="d-none"
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        const files = Array.from(e.target.files).filter(file => {
                          const ext = file.name.split('.').pop().toLowerCase();
                          return ['pdf', 'png', 'jpg', 'jpeg'].includes(ext);
                        });
                        const promises = files.map((file) => {
                          return new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.onload = () => {
                              resolve({
                                name: file.name,
                                data: reader.result,
                                size: file.size,
                              });
                            };
                            reader.readAsDataURL(file);
                          });
                        });
                        Promise.all(promises).then((results) => {
                          setMsmeDocuments([...msmeDocuments, ...results]);
                        });
                      }
                    }}
                  />
                  {msmeDocumentsUrl.length > 0 && (
                    <div className="mt-3">
                      {msmeDocumentsUrl.map((doc, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center justify-content-between p-2 mb-2"
                          style={{
                            backgroundColor: "#F9FAFB",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="#DC2626"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline
                                points="14 2 14 8 20 8"
                                fill="#DC2626"
                              />
                            </svg>
                            <div>
                              <div
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {doc.file_name ?? ""}
                              </div>
                              {/* <div
                                style={{ fontSize: "12px", color: "#6B7280" }}
                              >
                                {(doc.size / 1024 / 1024).toFixed(2)} MB
                              </div> */}
                            </div>
                          </div>
                          <X
                            size={20}
                            style={{ cursor: "pointer", color: "#DC2626" }}
                            onClick={() => {
                              const newDocs = msmeDocumentsUrl.filter(
                                (_, i) => i !== index,
                              );
                              setMsmeDocumentsUrl(newDocs);
                              if (doc.id) {
                                setRemovedMsmeDocuments([
                                  ...removedMsmeDocuments,
                                  doc.id,
                                ]);
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {msmeDocuments.length > 0 && (
                    <div className="mt-3">
                      {msmeDocuments.map((doc, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center justify-content-between p-2 mb-2"
                          style={{
                            backgroundColor: "#F9FAFB",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="#DC2626"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline
                                points="14 2 14 8 20 8"
                                fill="#DC2626"
                              />
                            </svg>
                            <div>
                              <div
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {doc.name}
                              </div>
                              <div
                                style={{ fontSize: "12px", color: "#6B7280" }}
                              >
                                {(doc.size / 1024 / 1024).toFixed(2)} MB
                              </div>
                            </div>
                          </div>
                          <X
                            size={20}
                            style={{ cursor: "pointer", color: "#DC2626" }}
                            onClick={() => {
                              const newDocs = msmeDocuments.filter(
                                (_, i) => i !== index,
                              );
                              setMsmeDocuments(newDocs);
                              if (doc.id) {
                                setRemovedMsmeDocuments([
                                  ...removedMsmeDocuments,
                                  doc.id,
                                ]);
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="m-2 bg-white rounded-4 p-3">
              <div className="row">
                <div className="col-xl-12">
                  <p className="fs-18 fw-600 mb-3">Bank details & Tax Info</p>
                </div>
                <div className="col-md-6 col-12">
                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="panNumberBank"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      PAN Number
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="panNumberBank"
                        placeholder="Enter here..."
                        maxLength={10}
                        value={panNumber}
                        onChange={(e) => {
                          setPanNumber(e.target.value.toUpperCase());
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.pan_number}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="taxCountry"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      Tax Country
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_country`}
                        placeholder="Select"
                        value={taxCountryOption}
                        onSelect={(item) => {
                          setTaxCountryOption(item);
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.tax_country_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="taxType"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      Tax Type
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${apiUrl}get_tax_types`}
                        placeholder="Select"
                        value={taxTypeOption}
                        onSelect={(item) => {
                          setTaxTypeOption(item);
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.tax_type}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="gstNumberBank"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      GST Number
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="gstNumberBank"
                        placeholder="Enter here..."
                        maxLength={15}
                        value={gstNumber}
                        onChange={(e) => {
                          setGstNumber(e.target.value.toUpperCase());
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.tax_number}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="currency"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      Currency
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${apiUrl}get_currency`}
                        placeholder="Select"
                        value={currencyOption}
                        onSelect={(item) => {
                          setCurrencyOption(item);
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.currency_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="vatNumberBank"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      VAT
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="vatNumberBank"
                        placeholder="Enter here..."
                        value={vatNumber}
                        onChange={(e) => {
                          setVatNumber(e.target.value);
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.vat_number}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-12">
                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="tanNumberBank"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      TAN
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="tanNumberBank"
                        placeholder="Enter here..."
                        maxLength={10}
                        value={tanNumber}
                        onChange={(e) => {
                          setTanNumber(e.target.value.toUpperCase());
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.tan_number}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="bankName"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      Bank Name
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="bankName"
                        placeholder="Enter bank name"
                        value={bankName}
                        onChange={(e) => {
                          setBankName(e.target.value);
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.bank_name}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="holderName"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      Holder Name
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="holderName"
                        placeholder="Enter holder name"
                        value={holderName}
                        onChange={(e) => {
                          setHolderName(e.target.value);
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.holder_name}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="accountNumber"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      Account Number
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="accountNumber"
                        placeholder="Enter here..."
                        maxLength={30}
                        value={accountNumber}
                        onChange={(e) => {
                          setAccountNumber(e.target.value.replace(/\D/g, ""));
                        }}
                        onKeyDown={(e) => {
                          if (
                            !/^\d$/.test(e.key) &&
                            !["Backspace", "Tab", "Delete", "ArrowLeft", "ArrowRight", "Enter"].includes(e.key) &&
                            !e.ctrlKey &&
                            !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.bank_account_number}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex align-items-start justify-content-start">
                    <label
                      htmlFor="ifscCode"
                      className="form-label fw-400 my-0 d-flex me-2 mt-2"
                      style={{ width: "130px" }}
                    >
                      IFSC Code
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="ifscCode"
                        placeholder="Enter"
                        maxLength={11}
                        value={ifscCode}
                        onChange={(e) => {
                          setIfscCode(
                            e.target.value.toUpperCase().slice(0, 11),
                          );
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "4px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.ifsc_code}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-12 mt-4">
                  <p className="fs-16 fw-600 mb-3">GST Documents</p>
                  <div
                    style={{
                      border: "1px dashed #E5E7EB",
                      borderRadius: "12px",
                      padding: "40px",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      document.getElementById("gstDocInput").click()
                    }
                    onDrop={(e) => {
                      e.preventDefault();
                      if (e.dataTransfer.files.length > 0) {
                        const files = Array.from(e.dataTransfer.files).filter(file => {
                          const ext = file.name.split('.').pop().toLowerCase();
                          return ['pdf', 'png', 'jpg', 'jpeg'].includes(ext);
                        });
                        const promises = files.map((file) => {
                          return new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.onload = () => {
                              resolve({
                                name: file.name,
                                data: reader.result,
                                size: file.size,
                              });
                            };
                            reader.readAsDataURL(file);
                          });
                        });
                        Promise.all(promises).then((results) => {
                          setGstDocuments([...gstDocuments, ...results]);
                        });
                      }
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    onDragEnter={(e) => e.preventDefault()}
                    onDragLeave={(e) => e.preventDefault()}
                  >
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#9CA3AF"
                        strokeWidth="1.5"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                        <polyline points="10 9 9 9 8 9" />
                      </svg>
                      <p
                        className="mt-3 mb-0"
                        style={{ color: "#6B7280", fontSize: "14px" }}
                      >
                        Drag and drop PDF files here or{" "}
                        <span style={{ color: "#3B82F6", fontWeight: "500" }}>
                          Choose from files
                        </span>
                      </p>
                    </div>
                  </div>
                  <input
                    id="gstDocInput"
                    type="file"
                    accept=".pdf,.png,.jpg,.jpeg"
                    multiple
                    className="d-none"
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        const files = Array.from(e.target.files).filter(file => {
                          const ext = file.name.split('.').pop().toLowerCase();
                          return ['pdf', 'png', 'jpg', 'jpeg'].includes(ext);
                        });
                        const promises = files.map((file) => {
                          return new Promise((resolve) => {
                            const reader = new FileReader();
                            reader.onload = () => {
                              resolve({
                                name: file.name,
                                data: reader.result,
                                size: file.size,
                              });
                            };
                            reader.readAsDataURL(file);
                          });
                        });
                        Promise.all(promises).then((results) => {
                          setGstDocuments([...gstDocuments, ...results]);
                        });
                      }
                    }}
                  />
                  {gstDocumentsUrl.length > 0 && (
                    <div className="mt-3">
                      {gstDocumentsUrl.map((doc, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center justify-content-between p-2 mb-2"
                          style={{
                            backgroundColor: "#F9FAFB",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="#DC2626"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline
                                points="14 2 14 8 20 8"
                                fill="#DC2626"
                              />
                            </svg>
                            <div>
                              <div
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {doc.file_name ?? ""}
                              </div>
                              {/* <div
                                style={{ fontSize: "12px", color: "#6B7280" }}
                              >
                                {(doc.size / 1024 / 1024).toFixed(2)} MB
                              </div> */}
                            </div>
                          </div>
                          <X
                            size={20}
                            style={{ cursor: "pointer", color: "#DC2626" }}
                            onClick={() => {
                              const newDocs = gstDocumentsUrl.filter(
                                (_, i) => i !== index,
                              );
                              setGstDocumentsUrl(newDocs);
                              if (doc.id) {
                                setRemovedGstDocuments([
                                  ...removedGstDocuments,
                                  doc.id,
                                ]);
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {gstDocuments.length > 0 && (
                    <div className="mt-3">
                      {gstDocuments.map((doc, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center justify-content-between p-2 mb-2"
                          style={{
                            backgroundColor: "#F9FAFB",
                            borderRadius: "8px",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="#DC2626"
                            >
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                              <polyline
                                points="14 2 14 8 20 8"
                                fill="#DC2626"
                              />
                            </svg>
                            <div>
                              <div
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {doc.name}
                              </div>
                              <div
                                style={{ fontSize: "12px", color: "#6B7280" }}
                              >
                                {(doc.size / 1024 / 1024).toFixed(2)} MB
                              </div>
                            </div>
                          </div>
                          <X
                            size={20}
                            style={{ cursor: "pointer", color: "#DC2626" }}
                            onClick={() => {
                              const newDocs = gstDocuments.filter(
                                (_, i) => i !== index,
                              );
                              setGstDocuments(newDocs);
                              if (doc.id) {
                                setRemovedGstDocuments([
                                  ...removedGstDocuments,
                                  doc.id,
                                ]);
                              }
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="m-2 bg-white rounded-4 p-3">
              <div className="row">
                <div className="col-xl-12">
                  <p className="fs-18 fw-600 ">Address Information </p>
                </div>
                <div className="col-md-6 col-12 ">
                  <p className="fs-12 fw-600 " style={{ color: "#64748B" }}>
                    SHIPPING ADDRESS{" "}
                  </p>
                  <div className="col-12 d-flex  align-items-start justify-content-start">
                    <label
                      htmlFor="Address"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      Address
                    </label>
                    <div className="w-100">
                      <textarea
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="Owner"
                        placeholder="Enter here"
                        rows={3}
                        value={shipAddress}
                        onChange={(e) => {
                          setShipAddress(e.target.value);
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.ship_address}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="Country"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      Country
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_country`}
                        placeholder="Select Country"
                        value={shipCountryOption}
                        onSelect={(item) => {
                          if (!shipCountryOption || shipCountryOption.value !== item?.value) {
                            setShipStateOption(null);
                            setShipCityOption(null);
                          }
                          setShipCountryOption(item);
                          if (isBillAddress) {
                            if (!billCountryOption || billCountryOption.value !== item?.value) {
                              setBillStateOption(null);
                              setBillCityOption(null);
                            }
                            setBillCountryOption(item);
                          }
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.ship_country_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="State"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      State
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_state?country_id=${
                          shipCountryOption != null
                            ? shipCountryOption.value
                            : ""
                        }`}
                        placeholder="Select State"
                        value={shipStateOption}
                        onSelect={(item) => {
                          setShipStateOption(item);
                          if (isBillAddress) {
                            setBillStateOption(item);
                          }
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.ship_state_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="City"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      City
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_city?state_id=${
                          shipStateOption != null ? shipStateOption.value : ""
                        }`}
                        placeholder="Select City"
                        value={shipCityOption}
                        onSelect={(item) => {
                          setShipCityOption(item);
                          if (isBillAddress) {
                            setBillCityOption(item);
                          }
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.ship_city_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="shipZipCode"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      Zip code
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="vendor-name"
                        placeholder="Enter here"
                        value={shipZipCode}
                        onChange={(e) => {
                          setShipZipCode(e.target.value);
                          if (isBillAddress) {
                            setBillZipCode(e.target.value);
                          }
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.ship_zipcode}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-12 ">
                  <div className="d-flex  align-items-center justify-content-between">
                    <p className="fs-12 fw-600 " style={{ color: "#64748B" }}>
                      BILLING ADDRESS{" "}
                    </p>
                    <div className="d-flex  align-items-center justify-content-start">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isBillAddress}
                        onChange={(e) => {
                          setIsBillAddress(e.target.checked);
                          if (e.target.checked) {
                            setBillAddress(shipAddress);
                            setBillCountryOption(shipCountryOption);
                            setBillStateOption(shipStateOption);
                            setBillCityOption(shipCityOption);
                            setBillZipCode(shipZipCode);
                          } else {
                            setBillAddress("");
                            setBillCountryOption(null);
                            setBillStateOption(null);
                            setBillCityOption(null);
                            setBillZipCode(null);
                          }
                        }}
                      />
                      <span className="ms-2">
                        Shipping same as billing address
                      </span>
                    </div>
                  </div>
                  <div className="col-12 d-flex  align-items-start justify-content-start">
                    <label
                      htmlFor="Address"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      Address
                    </label>
                    <div className="w-100">
                      <textarea
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="Owner"
                        placeholder="Enter here"
                        rows={3}
                        value={billAddress}
                        onChange={(e) => {
                          setBillAddress(e.target.value);
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.bill_address}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="Country"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      Country
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_country`}
                        placeholder="Select Country"
                        value={billCountryOption}
                        onSelect={(item) => {
                          if (!billCountryOption || billCountryOption.value !== item?.value) {
                            setBillStateOption(null);
                            setBillCityOption(null);
                          }
                          setBillCountryOption(item);
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.bill_country_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="State"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      State
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_state?country_id=${
                          billCountryOption != null
                            ? billCountryOption.value
                            : ""
                        }`}
                        placeholder="Select State"
                        value={billStateOption}
                        onSelect={(item) => {
                          setBillStateOption(item);
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.bill_state_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="City"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      City
                    </label>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_city?state_id=${
                          billStateOption != null ? billStateOption.value : ""
                        }`}
                        placeholder="Select City"
                        value={billCityOption}
                        onSelect={(item) => {
                          setBillCityOption(item);
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.bill_city_id}
                      </span>
                    </div>
                  </div>

                  <div className="mt-2 col-12 d-flex  align-items-center justify-content-start">
                    <label
                      htmlFor="billZipCode"
                      className="form-label  fw-400 my-0 d-flex me-2"
                      style={{ width: "130px" }}
                    >
                      Zip code
                    </label>
                    <div className="w-100">
                      <input
                        type="text"
                        className="form-control rounded-3 vendor-form-input"
                        id="vendor-name"
                        placeholder="Enter here"
                        value={billZipCode}
                        onChange={(e) => {
                          setBillZipCode(e.target.value);
                        }}
                      />{" "}
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                          marginTop: "0px",
                          marginLeft: "6px",
                        }}
                      >
                        {errorMsg.bill_zipcode}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
